import React, { useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import {
  InputGroup,
  Button,
  Col,
  Accordion,
  Card,
  Row,
  Spinner,
} from "react-bootstrap";

import _ from "lodash";
import { FormProvider, useForm, Controller } from "react-hook-form";
import DataGrid from "./DataGrid";
import { useLocation, useNavigate } from "react-router-dom";
import { AssignCommissionGroupToSupplier } from "./AssignCommissionGroupModal";
import AddCircle from "@mui/icons-material/AddCircleRounded";
import { tools } from "../../../core/utils/tools";
import SelectComponent from "../_Components/ReactSelectComponent";
import ApiAgentCommission from "../../../core/api/api.agentCommission";
import ApiSupplierAgentCommission from "../../../core/api/api.supplierAgentCommission";
import ApiSupplier from "../../../core/api/api.supplier";
import GlobalFormControl from "../_Components/GlobalFormControl";
import ApiAgent from "../../../core/api/api.agent";

const SupplierAgentCommission = () => {
  const [listData, setListData] = useState();
  const [showAddCommissionToAgentModal, setShowAddCommissionToAgentModal] =
    useState(false);
  const [selectedSupplierAgentCommissionId, setSelectedSupplierAgentCommissionId] = useState(false);
  const [selectedCheckBoxes, setSelectedCheckBoxes] = useState([]);
  const [supplierList, setSupplierList] = useState();
  const [agentCommissionList, setAgentCommissionList] = useState();
  const [allAgentList, setAllAgentList] = useState([]);


  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
    reset,
  } = useForm({});
  const methods = {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  };
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);

  useEffect(() => {
    (async () => {
      // دریافت لیست همه تامین کننده ها
      const suppliersList = await ApiSupplier.getAllSuppliersName();
      setSupplierList(suppliersList);
      try {
        const data =
          await ApiSupplierAgentCommission.getAllSupplierAgentCommissions({
            pageSize: getValues("pageSize"),
            pageNumber: getValues("pageNumber"),
            globalSearch: searchParams.get("globalSearch"),
            supplierId: searchParams.get("supplierId"),
            agentCommissionId: searchParams.get("agentCommissionId"),
          });

        setListData(data);
        setValue("totalCount", data.totalCount);
        const restAgent = await ApiAgent.getAllAgentsName();
        setAllAgentList(restAgent);
        const supplierId = searchParams.get("supplierId");
        if (supplierId) {
          const agentCommissions = await ApiAgentCommission.getAllAgentCommissionsBySupplierId({ supplierId });
          setAgentCommissionList(agentCommissions.data);
        }
        const formInputs = [
          { name: "globalSearch", type: "text", defaultValue: "" },
          { name: "pageSize", type: "number", defaultValue: "" },
          { name: "pageNumber", type: "number", defaultValue: "" },
          {
            name: "supplierId",
            type: "multiSelect",
            isMulti: false,
            data: suppliersList?.map((item) => ({
              id: item.id,
              title: item.companyName,
            })),
          },
          {
            name: "agentCommissionId",
            type: "multiSelect",
            isMulti: false,
            data: agentCommissionList?.map((item) => ({
              id: item.id,
              title: item.name,
            }))
          },
        ];

        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
        console.log("error :>> ", error);
      }
    })();
  }, []);
  const handleSupplierChange = async (supplierId) => {
    const agentCommissions = await ApiAgentCommission.getAllAgentCommissionsBySupplierId({ supplierId });
    setAgentCommissionList(agentCommissions.data);

    setValue('agentCommissionId', "");
  }
  const onSubmit = async (data) => {
    data.supplierId = data.supplierId?.value;
    data.agentCommissionId = data.agentCommissionId?.value;
    data.agentId = data.agentId?.value
    tools.setPageNumber(data, searchParams, setValue);
    const apiData =
      await ApiSupplierAgentCommission.getAllSupplierAgentCommissions(data);
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
    const queryString = tools.createQueryStringFromFromData(
      _.omit(data, ["totalPages", "totalCount"])
    );
    navigate(`/supplierAgentCommissions?${queryString}`);
  };

  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pb-3 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              تخصیص گروه کمیسیون به نمایندگان
            </span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">
              لیست گروه های کمیسیون تخصیص یافته به نمایندگان
            </span>
          </h3>
          <div className="card-toolbar">
            <Button
              className="btn btn-primary"
              onClick={() => {
                setSelectedSupplierAgentCommissionId(0);
                setShowAddCommissionToAgentModal(true);
              }}
            >
              <AddCircle className="mr-1" />
              تخصیص گروه کمیسیون به نمایندگان
            </Button>
          </div>
        </div>
        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search box */}
              <div className="border-top pt-3">
                <Accordion className="search">
                  <Card>
                    <Accordion.Header
                      as={Card.Header}
                      variant="link"
                      eventKey="0"
                    >
                      <Card.Title className="py-0 pl-0 fs-normal text-gray">
                        جستجو پیشرفته
                      </Card.Title>
                    </Accordion.Header>
                    <Accordion.Body eventKey="0">
                      <Card.Body>
                        <Row>
                          <Col sm="6" xl="3">
                            <Controller
                              name="supplierId"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-0 mb-5"
                                  options={supplierList?.map((item) => ({
                                    value: item.id,
                                    label: item.companyName,
                                  }))}
                                  placeholder="تامین کننده"
                                  field={field}
                                  onChange={(selectedOption) => {
                                    field.onChange(selectedOption); // مقدار فیلد در فرم آپدیت می‌شود
                                    handleSupplierChange(selectedOption?.value);
                                  }}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3">
                            <Controller
                              name="agentCommissionId"
                              control={control}
                              rules={{}}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-0 mb-5"
                                  placeholder=" گروه کمیسیون"
                                  options={agentCommissionList?.map((item) => ({
                                    value: item.id,
                                    label: item.name,
                                  }))}
                                  field={field}
                                />
                              )}
                            />
                            {/* <Controller
                              control={control}
                              name={"agentCommissionId"}
                              render={({ field }) => (
                                <Select
                                  name="service"
                                  // style={selectStyles}
                                  inputId="react-select-with-search"
                                  className="mt-5"
                                  variant="outlined"
                                  size="small"
                                  placeholder=" گروه کمیسیون"
                                  TextFieldProps={{
                                    label: "Services2",
                                    InputLabelProps: {
                                      htmlFor: "react-select-multiple",
                                      shrink: true,
                                    },
                                  }}
                                  options={allCommissionGroups?.map((item) => ({
                                    value: item.id,
                                    label: item.name,
                                  }))}
                                  {...field}
                                />
                              )}
                            /> */}
                          </Col>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive  px-2">
                            <Controller
                              name="agentId"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  options={allAgentList?.map((item) => ({
                                    value: item.id,
                                    label: item.companyName,
                                  }))}
                                  placeholder="نماینده"
                                  className="mt-0"
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row className="">
                          <Col xs="12" className="tb-reponsive">
                            <Button
                              variant="success"
                              type="submit"
                              className="py-2 mr-2 mb-2"
                              disabled={isSubmitting}
                            >
                              {isSubmitting && (
                                <Spinner
                                  animation="border"
                                  variant="warning"
                                  size="sm"
                                />
                              )}
                              <SearchIcon />
                              جستجو
                            </Button>
                            <Button
                              className="py-2 mb-2"
                              variant="light-danger"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() => {
                                tools.handleResetAdvanceSearchBox(watch, reset)
                                setAgentCommissionList([])
                              }
                              }
                            >
                              {isSubmitting && (
                                <Spinner
                                  animation="border"
                                  variant="warning"
                                  size="sm"
                                />
                              )}
                              <i className="fas fa-refresh text-small"></i>
                              حذف جستجو{" "}
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Accordion.Body>
                  </Card>
                </Accordion>
                <InputGroup className="my-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button
                    variant="secondary"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <Spinner animation="border" variant="warning" size="sm" />
                    ) : (
                      <SearchIcon />
                    )}
                  </Button>
                </InputGroup>
              </div>
              {/* table */}
              <Col xs="12" className="tb-reponsive px-0">
                <DataGrid
                  data={listData}
                  setSelectedSupplierAgentCommissionId={setSelectedSupplierAgentCommissionId}
                  setShowAddCommissionToAgentModal={
                    setShowAddCommissionToAgentModal
                  }
                  setSelectedCheckBoxes={setSelectedCheckBoxes}
                  selectedCheckBoxes={selectedCheckBoxes}
                />
              </Col>
            </form>
          </FormProvider>

          {showAddCommissionToAgentModal && (
            <AssignCommissionGroupToSupplier
              setShowAddCommissionToAgentModal={
                setShowAddCommissionToAgentModal
              }
              selectedSupplierAgentCommissionId={selectedSupplierAgentCommissionId}
              //selectedCheckBoxes={selectedCheckBoxes}
              // allSupplierAgents={allSupplierAgents}
              // allCommissionGroups={allCommissionGroups}
              supplierList={supplierList}
            />
          )}
        </div>
      </div>
    </div >
  );
};

export default SupplierAgentCommission;
